var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("drag-and-drop-wrapper", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var jsPlumbInstance = ref.jsPlumbInstance
          return [
            _c(
              "div",
              {
                staticClass: "track",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.moveToXViaTrack($event.x)
                  }
                }
              },
              [
                _c(
                  "drag-and-drop-draggable",
                  {
                    attrs: {
                      "js-plumb-instance": jsPlumbInstance,
                      containment: true
                    },
                    on: {
                      drag: function($event) {
                        return _vm.draggedToXViaNob($event.pos[0])
                      },
                      stop: function($event) {
                        return _vm.dragStoppedToXViaNob($event.pos[0])
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "nob",
                      class: { dragging: _vm.isDragging },
                      style:
                        "left: " +
                        _vm.nobTrackPosition +
                        "px; width: " +
                        _vm.nobWidth +
                        "px",
                      on: {
                        mousedown: function($event) {
                          _vm.isDragging = true
                        },
                        mouseup: function($event) {
                          _vm.isDragging = false
                        }
                      }
                    })
                  ]
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }